import { AnalyticsBrowser } from '@segment/analytics-next'; // Documentation: https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/

function getLogPlugin(config, isMock = false) {
  const isDev = config.environment !== 'production';
  return {
    name: 'Log Segment Events',
    type: 'before',
    version: '1.0.0',
    isLoaded: () => true,
    load: () => {
      isDev && console.log('[segment] logging events');
      return Promise.resolve();
    },
    track: ctx => {
      isDev && console.log('[segment] track', ctx);
      return ctx;
    },
    identify: ctx => {
      isDev && console.log('[segment] identify', ctx);
      return ctx;
    },
    page: ctx => {
      isDev && console.log('[segment] page', ctx);
      return ctx;
    },
    alias: ctx => {
      isDev && console.log('[segment] alias', ctx);
      return ctx;
    },
    group: ctx => {
      isDev && console.log('[segment] group', ctx);
      return ctx;
    },
    screen: ctx => {
      isDev && console.log('[segment] screen', ctx);
      return ctx;
    },

    setAnonymousId(ctx) {
      isDev && console.log('[segment] setAnonymousId', ctx);
      return ctx;
    },

    ...(isMock && {
      user: () => {
        return Promise.resolve({
          anonymousId: () => {
            return Promise.resolve(undefined);
          }
        });
      },
      register: () => {
        return Promise.resolve();
      }
    })
  };
}

function getAnalytics(config) {
  return new Promise(resolve => {
    AnalyticsBrowser.load({
      writeKey: config.segmentWriteKey
    }).then(([analytics]) => {
      resolve(analytics);
    }).catch(err => {
      console.log('Segment failed to load', err);
      resolve(getLogPlugin(config, true));
    });
  });
}

export default async function ({
  app,
  $config
}, inject) {
  const analytics = await getAnalytics($config);
  inject('segment', analytics);
  await analytics.register(getLogPlugin($config));

  try {
    // track page views
    app.router.afterEach(to => {
      try {
        setTimeout(() => {
          // don't fire on iframes
          if (window.self === window.top) {
            app.$segment.page('Website Visited', to.name, {
              referrer: to.params.page,
              ...to.query
            });
          }
        }, 1);
      } catch (err) {
        console.error('[segment] failed to report route change', err);
      }
    });
  } catch (err) {
    console.warn('[segment] error getting Growthbook flag');
  }
}